import React from 'react';
import { Navigate } from 'react-router-dom';

// Dashboard
import DashboardBlog from '../pages/DashboardBlog/index';


import MainPage from '../pages/MainPage';
import Tariff from '../pages/Tariff';
import AboutUs from '../pages/AboutUs';
import ContactUs from '../pages/ContactMessages';
import Faqs from '../pages/Faqs';
import RequestCoin from '../pages/CoinRequests';
import BlogCategories from '../pages/BlogCategories';
import BlogPosts from '../pages/BlogPosts';
import Comments from '../pages/Comments';

// Authentication Pages
import Login from '../pages/Authentication/Login';
import Logout from '../pages/Authentication/Logout';

const authProtectedRoutes = [
  { path: '/dashboard', component: <DashboardBlog /> },
  { path: '/main-page', component: <MainPage /> },
  { path: '/tariff', component: <Tariff /> },
  { path: '/aboutus', component: <AboutUs /> },
  { path: '/contact', component: <ContactUs /> },
  { path: '/faq', component: <Faqs /> },
  { path: '/requestCoin', component: <RequestCoin /> },
  { path: '/category', component: <BlogCategories /> },
  { path: '/post', component: <BlogPosts /> },
  { path: '/comment', component: <Comments /> },
  { path: '/', component: <Navigate to="/dashboard" /> },
  { path: '*', component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: '/logout', component: <Logout /> },
  { path: '/login', component: <Login /> },
];

export { authProtectedRoutes, publicRoutes };